/* eslint-disable @typescript-eslint/no-explicit-any */
import { EngineLocator, } from '../cblite-js/cblite';
import { IonicCouchbaseLite } from '../ionic-couchbase-lite';
import { v4 as uuidv4 } from 'uuid';
export class CapacitorEngine {
    constructor() {
        this._defaultCollectionName = '_default';
        this._defaultScopeName = '_default';
        EngineLocator.registerEngine(EngineLocator.key, this);
    }
    collection_AddChangeListener(args, cb) {
        return IonicCouchbaseLite.collection_AddChangeListener({
            name: args.name,
            scopeName: args.scopeName,
            collectionName: args.collectionName,
            changeListenerToken: args.changeListenerToken,
        }, cb);
    }
    collection_AddDocumentChangeListener(args, cb) {
        return IonicCouchbaseLite.collection_AddDocumentChangeListener({
            name: args.name,
            scopeName: args.scopeName,
            collectionName: args.collectionName,
            changeListenerToken: args.changeListenerToken,
            documentId: args.documentId,
        }, cb);
    }
    async collection_CreateCollection(args) {
        return IonicCouchbaseLite.collection_CreateCollection(args);
    }
    async collection_CreateIndex(args) {
        return IonicCouchbaseLite.collection_CreateIndex(args);
    }
    async collection_DeleteCollection(args) {
        return IonicCouchbaseLite.collection_DeleteCollection(args);
    }
    async collection_DeleteDocument(args) {
        return IonicCouchbaseLite.collection_DeleteDocument(args);
    }
    async collection_DeleteIndex(args) {
        return IonicCouchbaseLite.collection_DeleteIndex(args);
    }
    async collection_GetCollections(args) {
        return IonicCouchbaseLite.collection_GetCollections(args);
    }
    async collection_GetCollection(args) {
        return IonicCouchbaseLite.collection_GetCollection(args);
    }
    async collection_GetCount(args) {
        return IonicCouchbaseLite.collection_GetCount(args);
    }
    async collection_GetDefault(args) {
        return IonicCouchbaseLite.collection_GetDefault(args);
    }
    async collection_GetDocument(args) {
        return IonicCouchbaseLite.collection_GetDocument(args);
    }
    async collection_GetDocumentExpiration(args) {
        return IonicCouchbaseLite.collection_GetDocumentExpiration(args);
    }
    async collection_GetBlobContent(args) {
        const data = await IonicCouchbaseLite.collection_GetBlobContent(args);
        return { data: new Uint8Array(data.data).buffer };
    }
    async collection_GetIndexes(args) {
        return IonicCouchbaseLite.collection_GetIndexes(args);
    }
    async collection_PurgeDocument(args) {
        return IonicCouchbaseLite.collection_PurgeDocument(args);
    }
    async collection_RemoveChangeListener(args) {
        return IonicCouchbaseLite.collection_RemoveChangeListener(args);
    }
    async collection_RemoveDocumentChangeListener(args) {
        return IonicCouchbaseLite.collection_RemoveChangeListener(args);
    }
    async collection_Save(args) {
        return IonicCouchbaseLite.collection_Save(args);
    }
    async collection_SetDocumentExpiration(args) {
        return IonicCouchbaseLite.collection_SetDocumentExpiration(args);
    }
    async database_Close(args) {
        return IonicCouchbaseLite.database_Close(args);
    }
    async database_Copy(args) {
        return IonicCouchbaseLite.database_Copy(args);
    }
    async database_ChangeEncryptionKey(args) {
        return IonicCouchbaseLite.database_ChangeEncryptionKey(args);
    }
    /**
     * @deprecated This function will be removed in future versions. Use colllection_CreateIndex instead.
     */
    async database_CreateIndex(args) {
        const colArgs = {
            name: args.name,
            collectionName: this._defaultCollectionName,
            scopeName: this._defaultScopeName,
            indexName: args.indexName,
            index: args.index,
        };
        return IonicCouchbaseLite.collection_CreateIndex(colArgs);
    }
    async database_Delete(args) {
        return IonicCouchbaseLite.database_Delete(args);
    }
    async database_DeleteWithPath(args) {
        return IonicCouchbaseLite.database_DeleteWithPath(args);
    }
    /**
     * @deprecated This will be removed in future versions. Use collection_GetCount instead.
     */
    async database_DeleteDocument(args) {
        const colArgs = {
            name: args.name,
            collectionName: this._defaultCollectionName,
            scopeName: this._defaultScopeName,
            docId: args.docId,
            concurrencyControl: args.concurrencyControl,
        };
        return IonicCouchbaseLite.collection_DeleteDocument(colArgs);
    }
    /**
     * @deprecated This function will be removed in future versions. Use colllection_CreateIndex instead.
     */
    async database_DeleteIndex(args) {
        const colArgs = {
            name: args.name,
            collectionName: this._defaultCollectionName,
            scopeName: this._defaultScopeName,
            indexName: args.indexName,
        };
        return IonicCouchbaseLite.collection_DeleteIndex(colArgs);
    }
    async database_Exists(args) {
        return IonicCouchbaseLite.database_Exists(args);
    }
    /**
     * @deprecated This will be removed in future versions. Use collection_GetCount instead.
     */
    async database_GetCount(args) {
        const colArgs = {
            name: args.name,
            collectionName: this._defaultCollectionName,
            scopeName: this._defaultScopeName,
        };
        return IonicCouchbaseLite.collection_GetCount(colArgs);
    }
    /**
     * @deprecated This will be removed in future versions. Use collection_GetCount instead.
     */
    async database_GetDocument(args) {
        const colArgs = {
            name: args.name,
            collectionName: this._defaultCollectionName,
            scopeName: this._defaultScopeName,
            docId: args.docId,
        };
        return IonicCouchbaseLite.collection_GetDocument(colArgs);
    }
    /**
     * @deprecated This function will be removed in future versions. Use colllection_CreateIndex instead.
     */
    async database_GetIndexes(args) {
        const colArgs = {
            name: args.name,
            collectionName: this._defaultCollectionName,
            scopeName: this._defaultScopeName,
        };
        return IonicCouchbaseLite.collection_GetIndexes(colArgs);
    }
    async database_GetPath(args) {
        return IonicCouchbaseLite.database_GetPath(args);
    }
    async database_Open(args) {
        return IonicCouchbaseLite.database_Open(args);
    }
    async database_PerformMaintenance(args) {
        return IonicCouchbaseLite.database_PerformMaintenance(args);
    }
    /**
     * @deprecated This will be removed in future versions. Use collection_GetCount instead.
     */
    async database_PurgeDocument(args) {
        const colArgs = {
            name: args.name,
            collectionName: this._defaultCollectionName,
            scopeName: this._defaultScopeName,
            docId: args.docId,
        };
        return IonicCouchbaseLite.collection_PurgeDocument(colArgs);
    }
    /**
     * @deprecated This function will be removed in future versions. Use colllection_Save instead.
     */
    async database_Save(args) {
        const colArgs = {
            name: args.name,
            collectionName: this._defaultCollectionName,
            scopeName: this._defaultScopeName,
            id: args.id,
            document: JSON.stringify(args.document),
            blobs: JSON.stringify(args.blobs),
            concurrencyControl: args.concurrencyControl,
        };
        return IonicCouchbaseLite.collection_Save(colArgs);
    }
    async database_SetFileLoggingConfig(args) {
        return IonicCouchbaseLite.database_SetFileLoggingConfig(args);
    }
    async database_SetLogLevel(args) {
        return IonicCouchbaseLite.database_SetLogLevel(args);
    }
    /**
     * @deprecated This will be removed in future versions. Use collection_GetCount instead.
     */
    async document_GetBlobContent(args) {
        const colArgs = {
            name: args.name,
            collectionName: this._defaultCollectionName,
            scopeName: this._defaultScopeName,
            documentId: args.documentId,
            key: args.key
        };
        const data = await IonicCouchbaseLite.collection_GetBlobContent(colArgs);
        return { data: new Uint8Array(data.data).buffer };
    }
    async file_GetDefaultPath() {
        return IonicCouchbaseLite.file_GetDefaultPath();
    }
    async file_GetFileNamesInDirectory(args) {
        return IonicCouchbaseLite.file_GetFileNamesInDirectory(args);
    }
    async plugin_Configure(config) {
        return IonicCouchbaseLite.plugin_Configure({
            config,
        });
    }
    query_AddChangeListener(args, cb) {
        return IonicCouchbaseLite.query_AddChangeListener({
            name: args.name,
            query: args.query,
            parameters: args.parameters,
            changeListenerToken: args.changeListenerToken,
        }, cb);
    }
    async query_Execute(args) {
        return await IonicCouchbaseLite.query_Execute(args);
    }
    async query_Explain(args) {
        return await IonicCouchbaseLite.query_Explain(args);
    }
    async query_RemoveChangeListener(args) {
        return IonicCouchbaseLite.query_RemoveChangeListener(args);
    }
    replicator_AddChangeListener(args, cb) {
        return IonicCouchbaseLite.replicator_AddChangeListener(args, cb);
    }
    replicator_AddDocumentChangeListener(args, cb) {
        return IonicCouchbaseLite.replicator_AddDocumentChangeListener(args, cb);
    }
    async replicator_Cleanup(args) {
        return IonicCouchbaseLite.replicator_Cleanup(args);
    }
    async replicator_Create(args) {
        return await IonicCouchbaseLite.replicator_Create(args);
    }
    async replicator_GetStatus(args) {
        return IonicCouchbaseLite.replicator_GetStatus(args);
    }
    async replicator_GetPendingDocumentIds(args) {
        return IonicCouchbaseLite.replicator_GetPendingDocumentIds(args);
    }
    async replicator_IsDocumentPending(args) {
        return IonicCouchbaseLite.replicator_IsDocumentPending(args);
    }
    async replicator_ResetCheckpoint(args) {
        return IonicCouchbaseLite.replicator_ResetCheckpoint(args);
    }
    async replicator_RemoveChangeListener(args) {
        return IonicCouchbaseLite.replicator_RemoveChangeListener(args);
    }
    async replicator_Start(args) {
        return IonicCouchbaseLite.replicator_Start(args);
    }
    async replicator_Stop(args) {
        return IonicCouchbaseLite.replicator_Stop(args);
    }
    async scope_GetDefault(args) {
        return IonicCouchbaseLite.scope_GetDefault(args);
    }
    async scope_GetScope(args) {
        return IonicCouchbaseLite.scope_GetScope(args);
    }
    async scope_GetScopes(args) {
        return IonicCouchbaseLite.scope_GetScopes(args);
    }
    getUUID() {
        return uuidv4().toString();
    }
}
//# sourceMappingURL=capacitor-engine.js.map